import { useCallback, useRef } from 'react';

function useRefManager() {
  var storedRefs = useRef({});
  var refCallbacks = useRef({});
  var getRef = useCallback(function (id) {
    if (!refCallbacks.current[id]) {
      refCallbacks.current[id] = function (ref) {
        if (!storedRefs.current[id] && ref) {
          storedRefs.current[id] = ref;
        } else if (!ref) {
          delete storedRefs.current[id];
        }
      };
    }

    return refCallbacks.current[id];
  }, []);
  return [storedRefs, getRef];
}

export default useRefManager;